function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import includes from 'lodash/includes';
import { mapState } from 'vuex';
export default {
  props: {
    index: {
      type: Number,
      required: true
    },
    row: {
      type: Object,
      required: true
    }
  },
  computed: _objectSpread({}, mapState({
    elementType: function elementType(s) {
      return s.elements.type;
    }
  })),
  methods: {
    isMatch: function isMatch(element) {
      return includes(this.row.matches, element.search_index);
    },
    showContext: function showContext() {
      var query = {
        text: this.row.text.id,
        matches: this.row.matches,
        example: this.index,
        type: this.elementType
      };
      this.$store.dispatch('api/executeDetail', {
        type: 'context',
        query: query
      });
      this.$ga.page("/search/context");
    }
  }
};